<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button
          class="page-panel-header-control-button"
          size="mini"
          type="primary"
          @click="back"
        >返回</el-button>
      </div>
      <div class="page-panel-header__title">图文资讯</div>
    </div>
    <div class="page-panel__body">
      <el-form ref="form" label-width="100px">
        <el-form-item label="活动标题">
          <el-input v-model="newsParam.newsTitle" placeholder="请输入新闻标题"></el-input>
        </el-form-item>
        <el-form-item label="主办方">
          <el-input v-model="newsParam.newsMainOrg" placeholder="请输入主办方"></el-input>
        </el-form-item>
        <el-form-item label="活动日期">
          <el-date-picker
            v-model="newsParam.newsDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="会务/活动地点">
          <el-col :span="5">
            <el-cascader size="large" :options="options" v-model="address" @change="handleChange"></el-cascader>
          </el-col>
          <el-col :span="19">
            <el-input placeholder="请补充详细的地址信息" v-model="newsParam.newsArea"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="活动封面">
          <img
            :src="newsParam.newsMainImg"
            alt
            v-if="newsParam.newsMainImg"
            @click="avatarEditorVisable=true"
            class="avartar_img"
          />
          <el-button type="primary" @click="avatarEditorVisable=true" v-else>上传图片</el-button>
        </el-form-item>
        <el-form-item label="文章编辑">
          <ueditor :config="editorConfig" v-model="newsParam.newsText"></ueditor>
        </el-form-item>
        <el-form-item label="标签/关键字">
          <new-tag :dynamicTags="dynamicTags" v-model="newsParam.newsTarget"></new-tag>
        </el-form-item>
      </el-form>
      <div class="article_footer_control">
        <el-button type="primary" @click="addNews">发布</el-button>
      </div>
    </div>
    <avatar-editor
      url="/file/upload"
      :width="150"
      :height="220"
      field="file"
      @crop-upload-success="uploadSuccess"
      :visible.sync="avatarEditorVisable"
    ></avatar-editor>
  </div>
</template>
<script>
import avatarEditor from '@/common/component/avatarEditor';
import { sessionStorage } from '@/common/util/storage';
import * as newsApi from '@/api/industryIdynamics';
import { regionData, CodeToText } from 'element-china-area-data';
// import axios from 'axios';
const commonJSON = require('@/common/Json/index');
export default {
  data () {
    return {
      options: regionData,
      newsId: null,
      avatarEditorVisable: false,
      commonJSON,
      uploadUrl: {
        default: '/file/upload',
        type: 'string'
      },
      dialogVisible1: false,
      // 裁剪组件的基础配置option
      picsList: [],
      // 防止重复提交
      loading: false,
      newsClassification: sessionStorage.get('getdiclist2'),
      newsParam: {
        newsCategory: 2
      },
      dialogImageUrl: '',
      dialogVisible: false,
      dynamicTags: [],
      // 富文本框初始化
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      }
    };
  },
  // 新增公钥
  components: {
    avatarEditor
  },
  methods: {
    checkInfo (info) {
      if (!info.newsTitle) {
        this.$notify({
          title: '警告',
          message: '请输入活动标题',
          type: 'warning'
        });
        return false;
      } else if (info.newsTitle.length > 70) {
        this.$notify({
          title: '警告',
          message: '标题字数不能超过70',
          type: 'warning'
        });
        return false;
      } else if (!info.newsMainOrg) {
        this.$notify({
          title: '警告',
          message: '请输入主办方',
          type: 'warning'
        });
        return false;
      } else if (info.newsMainOrg.length > 70) {
        this.$notify({
          title: '警告',
          message: '主办方字数不能超过70',
          type: 'warning'
        });
        return false;
      } else if (!info.newsArea) {
        this.$notify({
          title: '警告',
          message: '请输入详细地址',
          type: 'warning'
        });
        return false;
      } else if (info.newsArea.length > 70) {
        this.$notify({
          title: '警告',
          message: '详细地址字数不能超过70',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    handleChange (value) {
      var ctt =
        CodeToText[value[0]] + CodeToText[value[1]] + CodeToText[value[2]];
      this.newsParam.newsAddress = this.address.join(',');
      console.log(ctt);
    },
    uploadSuccess (response, file, fileList) {
      this.newsParam.newsMainImg = response.url;
      this.avatarEditorVisable = false;
    },
    changeUpload (file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        return false;
      }
      this.fileinfo = file;
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = file.url;
        this.dialogVisible1 = true;
      });
    },
    addNews () {
      if (this.checkInfo(this.newsParam)) {
        newsApi.addNews(this.newsParam).then(res => {
          this.$router.push({
            path: '/admin/allianceActivities'
          });
        });
      }
    },
    getNewsDetail () {
      newsApi.getNewsDetail({ newsId: this.newsId }).then(res => {
        this.newsParam = res.data;
      });
    },
    back () {
      this.$router.push({
        path: '/admin/allianceActivities'
      });
    },
    handleRemove (file) {
      console.log(file);
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  created () {
    this.newsId = this.$route.params.newsId;
    this.getNewsDetail();
  }
};
</script>
<style lang="stylus" scoped>
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--date {
  width: 100%;
}

.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/allianceActivities/Edit.vue